import { VendorLineItemRecord } from '../../../api/types';

export const formatInventoryDescription = (value?: string) => {
    const text = (value || '').trim();
    if (!text) return '—';

    const lettersOnly = text.replace(/[^A-Za-z]+/g, '');
    const isAllCaps = lettersOnly.length >= 6 && lettersOnly === lettersOnly.toUpperCase();
    if (!isAllCaps) {
        return text;
    }

    return text
        .toLowerCase()
        .replace(/\b\w/g, (match) => match.toUpperCase());
};

export const formatInventoryDisplayName = (item: VendorLineItemRecord) => {
    const description = formatInventoryDescription(item.description || item.canonical_name);
    const brandName = String(item.brand_name || '').trim();
    if (description !== '—' && brandName) {
        return `${description} - ${brandName}`;
    }
    return description;
};

export const formatInventoryVendors = (item: VendorLineItemRecord) => {
    const vendorNames = (item.vendors || []).filter(Boolean);
    if (vendorNames.length > 0) {
        return vendorNames.join(', ');
    }
    if (item.vendor_name) {
        return item.vendor_name;
    }
    return '—';
};

export const getInventoryVendorList = (item: VendorLineItemRecord) => {
    const vendorNames = (item.vendors || []).filter(Boolean);
    if (vendorNames.length > 0) {
        return vendorNames;
    }
    return item.vendor_name ? [item.vendor_name] : [];
};
